import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";

import { useAppDispatch } from "../../redux";
import {
  getCustomerMetricsAction,
  getHighValueCustomersAction,
} from "../../redux/dashboard/analytics.slice";

import { useAnalyticsFilter } from "../../context/AnalyticsFilterContext";

import Icon from "../../assets/svg";
import dotPurple from "../../assets/svg/dot_purple.svg";
import graphNewIcon from "../../assets/svg/graph-new.svg";

import Loader from "../../components/loader";
import NoData from "../../components/no-data";
import AnalyticsFilter from "./analytics-filter";

interface CustomerMetric {
  name: string;
  value: number;
  status: string;
  percentage: number;
}

interface CustomerDetails {
  name: string;
  total_orders: string;
  total_spent: string;
}

const CustomerAnalytics = () => {
  const dispatch = useAppDispatch();
  const {
    isFetchingCustomerMetrics,
    customerMetrics,
    isFetchingHighValueCustomers,
    highValueCustomers,
  } = useSelector((state: any) => state.analyticsSlice);
  const { duration } = useAnalyticsFilter();
  const [showMetricsDropDown, setShowMetricsDropDown] = useState(false);

  const metricRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    dispatch(getHighValueCustomersAction());
  }, []);

  useEffect(() => {
    dispatch(getCustomerMetricsAction({ range: duration }));
  }, [duration]);

  return (
    <div>
      <AnalyticsFilter ref={metricRef} disableActions={true} />
      <div className="analytics_details">
        <div className="left">
          <div className="dropdown">
            <div
              className={classNames("metric_charts customers", {
                focused: showMetricsDropDown,
              })}
              onClick={() => setShowMetricsDropDown((prev) => !prev)}
            >
              <div className="text_right">
                <img src={graphNewIcon} alt="" />
                <p>
                  Customer Metrics{"  "}
                  <span>
                    See total customers, first time customers, repeat customers,
                    and total purchase
                  </span>
                </p>
              </div>
              <Icon name="chevronDown" />
            </div>
            {showMetricsDropDown && (
              <div className="dropdown_content">
                {isFetchingCustomerMetrics ? (
                  <Loader />
                ) : !customerMetrics || customerMetrics?.length === 0 ? (
                  <NoData text="No customer metrics to show" />
                ) : (
                  <div className="content_details" ref={metricRef}>
                    {customerMetrics.map((metric: CustomerMetric) => (
                      <div className="metric_card" key={metric?.name}>
                        <p>{metric?.name}</p>
                        <div className="bottom">
                          <p>{metric?.value}</p>
                          <div
                            className={classNames("tag", {
                              decrease: metric?.status === "decrease",
                              increase: metric?.status === "increase",
                            })}
                          >
                            {(metric?.status === "decrease" ||
                              metric?.status === "increase") && (
                              <Icon
                                name={
                                  metric?.status === "decrease"
                                    ? "arrowDown"
                                    : "arrowUp"
                                }
                              />
                            )}
                            <p>{metric?.percentage}%</p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>

          {/* <div className="dropdown">
       <div className="metric_charts mt customers">
         <div className="text_right">
           <img src={presentationGraphIcon} alt="" />
           <p>
             Graphs and Charts{"  "}
             <span>See customer growth trend</span>
           </p>
         </div>
         <Icon name="chevronDown" />
       </div>
     </div> */}
        </div>
        <div className="right">
          <p className="heading">High-Value Customers</p>
          {isFetchingHighValueCustomers ? (
            <Loader />
          ) : !highValueCustomers || highValueCustomers?.length === 0 ? (
            <NoData text="No customers" />
          ) : (
            <>
              {highValueCustomers
                .filter((_data: any, i: number) => i < 10)
                ?.map((customer: CustomerDetails, i: number) => (
                  <div className="customer_data" key={i}>
                    <img src={dotPurple} alt="" />
                    <div className="data">
                      <p>{customer.name}</p>
                      <p>
                        <span>{customer.total_orders}</span> purchases, spent{" "}
                        <span>{customer.total_spent}</span>
                      </p>
                    </div>
                  </div>
                ))}
              {/* <p className="more customers">See More...</p> */}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomerAnalytics;
